import { render, staticRenderFns } from "./EmailGroup.vue?vue&type=template&id=4a1ee70a&"
import script from "./EmailGroup.vue?vue&type=script&lang=ts&"
export * from "./EmailGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports